import { render } from "./SmsSenderNameModal.vue?vue&type=template&id=523f616c&scoped=true"
import script from "./SmsSenderNameModal.vue?vue&type=script&lang=js"
export * from "./SmsSenderNameModal.vue?vue&type=script&lang=js"

import "./SmsSenderNameModal.vue?vue&type=style&index=0&id=523f616c&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523f616c"]])

export default __exports__